// import { CallsGraphs } from "./callsInsights/CallsGraphs";
import { CallsInsights } from "./callsInsights/CallsInsights";

export const CallsInsightsContainer = () => {
  return(
    <div>
      {/* <CallsGraphs/> */}
      <CallsInsights />

    </div>
      );
};

export default CallsInsightsContainer;
